import React from 'react';
import {
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	Button,
	Box,
	Typography,
	Chip,
	Divider,
} from '@mui/material';
import { SystemNotificationReceiverRecord } from './SystemNotificationReceiverDialog';

interface Props {
	open: boolean;
	onClose: () => void;
	receiver: SystemNotificationReceiverRecord | null;
}

const Field: React.FC<{ label: string; value?: string }> = ({ label, value }) => (
	<Box mb={1} sx={{ minWidth: 180 }}>
		<Typography variant="caption" color="text.secondary" display="block">
			{label}
		</Typography>
		<Typography variant="body2" sx={{ wordBreak: 'break-word' }}>
			{value || '—'}
		</Typography>
	</Box>
);

const formatDate = (value?: string) => {
	if (!value) return undefined;
	try {
		return new Date(value).toLocaleString();
	} catch {
		return value;
	}
};

export const SystemNotificationReceiverViewDialog: React.FC<Props> = ({
	open,
	onClose,
	receiver,
}) => {
	if (!receiver) return null;

	const fullName = `${receiver.title} ${receiver.firstName} ${receiver.lastName}`.trim();

	return (
		<Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
			<DialogTitle>
				<Box display="flex" alignItems="center" gap={1} flexWrap="wrap">
					Receiver Details
					<Chip
						label={receiver.title}
						size="small"
						color="secondary"
						sx={{ fontWeight: 600 }}
					/>
				</Box>
			</DialogTitle>
			<DialogContent dividers>
				<Typography variant="subtitle2" color="text.secondary" sx={{ mb: 1 }}>
					Contact
				</Typography>
				<Box display="flex" gap={4} flexWrap="wrap" mb={2}>
					<Field label="Full Name" value={fullName} />
					<Field label="Title" value={receiver.title} />
					<Field label="First Name" value={receiver.firstName} />
					<Field label="Last Name" value={receiver.lastName} />
				</Box>

				<Divider sx={{ my: 2 }} />
				<Typography variant="subtitle2" color="text.secondary" sx={{ mb: 1 }}>
					Channels
				</Typography>
				<Box display="flex" gap={4} flexWrap="wrap" mb={2}>
					<Field label="WhatsApp Number" value={receiver.whatsappNumber} />
					<Field label="Mobile Number" value={receiver.mobileNumber} />
					<Field label="Email" value={receiver.email} />
				</Box>

				<Divider sx={{ my: 2 }} />
				<Typography variant="subtitle2" color="text.secondary" sx={{ mb: 1 }}>
					Audit
				</Typography>
				<Box display="flex" gap={4} flexWrap="wrap">
					<Field label="Created By" value={receiver.createdBy} />
					<Field label="Updated By" value={receiver.updatedBy} />
					<Field label="Created At" value={formatDate(receiver.createdAt)} />
					<Field label="Updated At" value={formatDate(receiver.updatedAt)} />
				</Box>
			</DialogContent>
			<DialogActions>
				<Button variant="outlined" color="secondary" onClick={onClose}>
					Close
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default SystemNotificationReceiverViewDialog;
